/**
 * Extracts the file name from a full path by returning the text after the last slash.
 * @param fullPath
 * @param fallback
 * @returns only the file name from the full path, or the fallback value if no file name is found.
 */
export const extractFileNameFromFullPath = (fullPath: string, fallback = ''): string => {
  return fullPath.split('/').pop() || fallback
}
